export default __webpack_public_path__ + "static/media/bunnyhead-max.bb2310de.svg";